export const i18nLanguageList = [
  { name: "čeština", code: "cs" },
  { name: "dansk", code: "da" },
  { name: "Deutsch", code: "de" },
  { name: "English", code: "en" },
  { name: "English-UK", code: "en-uk" },
  { name: "Spanish (Latin America)", code: "es-419" },
  { name: "Castilian Spanish", code: "es-es" },
  { name: "Spanish", code: "es" },
  { name: "Mexico ( Español )", code: "es-mx" },
  { name: "American Spanish", code: "es-us" },
  { name: "suomi", code: "fi" },
  { name: "Français", code: "fr" },
  { name: "Italiano", code: "it" },
  { name: "한국어", code: "ko" },
  { name: "norsk", code: "nb" },
  { name: "Dutch", code: "nl" },
  { name: "Polski", code: "pl" },
  { name: "Português", code: "pt" },
  { name: "Português do Brasil", code: "pt-br" },
  { name: "română", code: "ro" },
  { name: "ру́сский", code: "ru" },
  { name: "svenska", code: "sv" },
  { name: "Türkçe", code: "tr" },
  { name: "简体字", code: "zh-cn" },
  { name: "日本", code: "ja" }
];

export const languageNames = {
  cs: "cs",
  da: "da",
  de: "de",
  "en-uk": "enUK",
  en: "en",
  "es-419": "es419",
  "es-es": "esES",
  "es-mx": "esMX",
  "es-us": "esUS",
  es: "es",
  fi: "fi",
  fr: "fr",
  it: "it",
  ko: "ko",
  nb: "nb",
  nl: "nl",
  pl: "pl",
  "pt-br": "ptBR",
  pt: "pt",
  ro: "ro",
  ru: "ru",
  sv: "sv",
  tr: "tr",
  xx: "xx",
  "zh-cn": "zhCN",
  ja: "ja"
}
